export default {
  'AI Face Animator': 'AI臉部特效',
  'Create incredible facial expressions with brainwashing music, find the magic for fun.': '魔性表情，洗腦音樂，盡享火爆樂趣。',
  'Upload a photo': '上傳一張圖片',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.': '注意：選擇的照片中，人臉必須面向鏡頭，否則不能成功處理。',
  'Uploaded successfully!': '上傳成功！',
  'Please select a template below': '請在下方選擇一個範本',
  'Choose a GIF': '選擇一個GIF',
  'Use this template': '選擇這個',
  'Verify successfully! You will': '驗證成功！不久你就會通過{{email}}收到影片！',
  'You will': '不久你就會通過{{email}}收到影片！',
  'What you should expect to happen next': '接下來會發生什麼？',
  'We will process your photo into a dynamic video.': '我們會把你的圖片處理成一個動態的影片。',
  'After processing, we will send the video to your email.': '處理結束後，我們會發送影片到你的郵箱。',
  'You can check the video in your email.': '你可以在郵箱查收影片。',
  'Your video will be delivered via email': '我們會通過郵件將影片發送給你',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.': '合成動態影片需要20-30分鐘，請耐心等待。為了你的隱私安全，在處理結束後，你的圖片會被自動刪除。',
  'Your Email': '你的郵箱',
  'Last Name': '名字',
  'First Name': '姓氏',
  'Go back': '返回',
  'Invalid email address':'無效郵箱',
  'Enter verification code':'輸入驗證碼',
  'Enter the verification code that we sent to': '輸入我們發送給{{email}}的驗證碼。',
  'Resend': '重新發送',
  'Verification code': '驗證碼',
  'Resend after': '{{num}}s後重新發送',
  'The verification code is invalid. You can request a new one.': '無效的驗證碼，你可以再次請求驗證碼。',
  'Synthesize Video': '合成影片',
  'Too many attempts, please try again later.': '请求频繁，请稍后再试。',
}